import { MatDialog } from "@angular/material/dialog";
import { BackendApiService } from "./../shared/services/backend-api.service";
import { SessionService } from "./../shared/services/session.service";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { ConstantService } from "../shared/constant/constant.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { User } from "../shared/class/user";
import { timeout } from "rxjs/operators";
import { PrivacyComponent } from "../privacy/privacy.component";
import { TAndCComponent } from "../t-and-c/t-and-c.component";
import { LoginComponent } from "../login/login.component";
import { MessageserviceService } from "../shared/services/messageservice.service";

@Component({
  selector: "app-registration",
  templateUrl: "./registration.component.html",
  styleUrls: ["./registration.component.css"],
})
export class RegistrationComponent implements OnInit {
  newuser: User;
  countryList: any;
  usermobile: any;
  country: any;
  userphone: any;
  packageList: any[];
  userActivePackage: any;
  subscription: any;
  showPackageSection: boolean = false;

  constructor(
    private snackBar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService,
    private sessionService: SessionService,
    private backendApiService: BackendApiService,
    public user: User,
    public dialog: MatDialog,
    private messageservice: MessageserviceService
  ) {}

  hide = true;

  signUpData(model, isValid: boolean) {
    if (isValid) {
      this.user.loginStatus = true;
      if (
        model.email !== "" &&
        model.password !== "" &&
        model.password !== "" &&
        model.firstName !== "" &&
        model.lastName !== "" &&
        model.mobile !== null &&
        model.confPassword !== "" &&
        this.country !== ""
      ) {
        const inputData = {
          loginType: 0,
          deviceType: 6,
          emailId: model.email,
          password: model.password,
          mobileNumber: model.mobile,
          landlineNumber: model.phone,
          country: this.country,
          macId: "",
          uuid: "",
          friendlyName: "",
          notificationId: "",
          socialMediaId: "",
          authToken: "",
          name: model.firstName,
          emailVerficationStatus: 0,
          mobileVerficationStatus: 0,
          imageUrl: "",
          address: model.address,
          lastName: model.lastName,
          city: model.city,
          postCode: model.postcode,
        };
        this.spinnerService.show();
        this.backendApiService.postRawRequest("sign_up", inputData).subscribe(
          (response: any) => {
            if (response.responseCode === "SC101") {
              this.newuser = new User();
              this.newuser = <User>response.userDetails;
              this.newuser.loginStatus = true;
              this.sessionService.setData(this.newuser);
              if (response.token)
                this.sessionService.setUsertoken(response.token);
              this.snackBar.open("Successfully signed in", "", {
                duration: 2000,
              });
              this.messageservice.sendMessage("logined");
              this.showPackageSection = true;
              // setTimeout(() => {
              //   location.reload();
              // }, 2000);
            } else if (response.responseCode != "SC101") {
              this.snackBar.open(response.message, "", {
                duration: 2000,
              });
            } else if (response.responseCode === "FC101") {
              this.snackBar.open("Something went wrong", "close", {
                duration: 2000,
              });
            } else {
              this.snackBar.open("Sign up process failed", "", {
                duration: 3000,
              });
            }
          },
          (error) => {
            this.snackBar.open(
              new DOMParser()
                .parseFromString(error.error, "text/html")
                .getElementsByTagName("p")[1]
                .textContent.replace("message", ""),
              "",
              {
                duration: 2000,
                verticalPosition: "top",
                horizontalPosition: "center",
                direction: "ltr",
              }
            );
          }
        );
      } else {
        this.snackBar.open("please fill all details", "", {
          duration: 2000,
        });
      }
    }
  }
  openLogin() {
    this.dialog.closeAll();
    this.dialog.open(LoginComponent, {
      height: "350px",
    });
  }
  openPrivacy() {
    this.dialog.open(PrivacyComponent, {
      height: "350px",
    });
  }
  openTandC() {
    this.dialog.open(TAndCComponent, {
      height: "100%",
    });
  }
  getCountrylist() {
    const requestData = {};

    this.countryList = [];

    this.backendApiService
      .postRawRequest("getCountryList", requestData)
      .subscribe(
        (response: any) => {
          if (response.responseCode === "SC101") {
            this.countryList = response.countryList;
          } else if (response.responseCode === "FC101") {
            this.snackBar.open("Something went wrong", "", {
              duration: 2000,
            });
          } else {
            this.snackBar.open("Server error", "", {
              duration: 3000,
            });
          }
        },
        (error) => {
          this.snackBar.open(
            new DOMParser()
              .parseFromString(error.error, "text/html")
              .getElementsByTagName("p")[1]
              .textContent.replace("message", ""),
            "",
            {
              duration: 2000,
              verticalPosition: "top",
              horizontalPosition: "center",
              direction: "ltr",
            }
          );
        }
      );
  }
  sendMessage(user: any) {
    // send message to subscribers via observable subject
    this.messageservice.sendMessage(user);
  }

  clearMessage(): void {
    // clear message
    this.messageservice.clearMessage();
  }

  ngOnInit() {
    this.user = new User();
    this.getCountrylist();
  }
}



// WEBPACK FOOTER //
// ./src/app/registration/registration.component.ts